export default "__VITE_ASSET___Og6dl9l__"